import AppView from "./views/AppView";
import PolicyGraph from "./model/PolicyGraph";
import state from "./state";

const app = new AppView();

//app lifecycle here
//app.mount();

function loadingComplete() {
  document.body.classList.replace("is-loading", "is-loaded");
}

Promise.all([
  fetch("/data/policies.json"),
  fetch("/data/stats.csv")]
).then(([entries, stats]) => {
  return Promise.all([entries.json(), stats.text()]);
}).then(([policyData, statsData]) => {
  const graph = PolicyGraph.load(policyData, statsData);
  state.channel.publish("onGraphLoaded", graph);
  loadingComplete();
});
